const optionsBoolean = [
    { value: "true", label: "Sim" },
    { value: "false", label: "Não" },
];

export default optionsBoolean;